import React, { useEffect, useMemo, useState } from 'react';
import Icon from '../../common/Icons';

const animateValue = (from, to, progress) => Math.round(from + (to - from) * progress);

const StatCard = ({ title, value = 0, icon = 'chartBar', tone = 'indigo', subtitle }) => {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    let frame = null;
    const start = performance.now();
    const from = displayValue;
    const duration = 500;

    const tick = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      setDisplayValue(animateValue(from, Number(value || 0), progress));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };

    frame = requestAnimationFrame(tick);
    return () => {
      if (frame) cancelAnimationFrame(frame);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const toneClass = useMemo(() => `dashboard-stat-card tone-${tone}`, [tone]);

  return (
    <article className={toneClass}>
      <div className="dashboard-stat-head">
        <span className="dashboard-stat-title">{title}</span>
        <span className="dashboard-stat-icon">
          <Icon name={icon} size={16} />
        </span>
      </div>
      <div className="dashboard-stat-value">{displayValue.toLocaleString('fr-FR')}</div>
      {subtitle ? <div className="dashboard-stat-subtitle">{subtitle}</div> : null}
    </article>
  );
};

export default StatCard;
